// user/* 페이지 번역
const user = {
  notice: {
    filter: {
      category: '카테고리',
      status: '상태',
      all: '전체',
      categories: {
        system: '시스템',
        equipment: '장비',
        quality: '품질',
        alert: '알림설정',
        education: '교육',
        general: '일반',
      },
      statuses: {
        active: '게시중',
        waiting: '대기',
        scheduled: '예정',
        inactive: '비활성',
        ended: '종료',
      },
    },
    searchPlaceholder: '제목, 내용 검색',
    addBtn: '공지사항 등록',
    col: {
      category: '카테고리',
      startDate: '시작일',
      endDate: '종료일',
      title: '제목',
      author: '작성자',
      priority: '우선순위',
      status: '상태',
      views: '조회수',
      createdAt: '작성일',
      action: '작업',
    },
    priority: {
      high: '높음',
      normal: '보통',
      low: '낮음',
    },
    addModal: {
      title: '공지사항 등록',
    },
    editModal: {
      title: '공지사항 수정',
    },
    form: {
      titleLabel: '제목',
      titlePlaceholder: '공지사항 제목을 입력하세요',
      categoryLabel: '카테고리',
      priorityLabel: '우선순위',
      pinnedLabel: '상단 고정',
      pinnedHint: '헤더에 공지 표시',
      startDateLabel: '게시 시작일',
      endDateLabel: '게시 종료일',
      contentLabel: '내용',
      contentPlaceholder: '공지사항 내용을 입력하세요',
    },
    actions: {
      register: '등록',
      cancel: '취소',
      update: '수정',
      delete: '삭제',
    },
    seed: {
      defaultCategory: '공지',
      defaultAuthor: '관리자',
    },
    deleteModal: {
      title: '공지 삭제',
      message: '"{title}" 공지를 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.',
      confirm: '삭제',
      cancel: '취소',
    },
    alertDeleted: '"{title}" 공지가 삭제되었습니다.',
    alertDeleteFail: '공지 삭제에 실패했습니다.',
    alertTitleRequired: '제목을 입력해주세요.',
    alertContentRequired: '내용을 입력해주세요.',
    alertEndAfterStart: '종료일은 시작일 이후여야 합니다.',
    alertCreateSuccess: '공지사항이 성공적으로 등록되었습니다.',
    alertCreateFail: '공지사항 등록에 실패했습니다.',
    alertUpdateSuccess: '공지사항이 성공적으로 수정되었습니다.',
    alertUpdateFail: '공지사항 수정에 실패했습니다.',
  },
  role: {
    searchPlaceholder: '권한명, 권한코드 검색...',
    addBtn: '권한 추가',
    loading: '데이터를 불러오는 중...',
    col: {
      name: '권한명',
      code: '권한코드',
      count: '권한 수',
      scope: '권한 범위',
      description: '설명',
      action: '작업',
    },
    countSuffix: '{n}개',
    permissionCount: '({n}개)',
    permissionSelected: '({n}개 선택)',
    misc: {
      etcCategory: '기타',
      noPermissions: '권한이 설정되지 않았습니다.',
    },
    detailModal: {
      titleEdit: '권한 그룹 수정',
      titleView: '권한 그룹 상세정보',
      groupNameLabel: '권한 그룹명',
      groupNamePlaceholder: '권한 그룹명을 입력하세요',
      codeLabel: '권한코드',
      codePlaceholder: '권한코드를 입력하세요',
      descriptionLabel: '설명',
      descriptionPlaceholder: '설명을 입력하세요',
      permissionsLabel: '권한 목록',
      save: '저장',
      cancel: '취소',
      edit: '수정',
      close: '닫기',
    },
    deleteModal: {
      title: '권한 그룹 삭제',
      message: '"{name}" 권한 그룹을 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.',
      confirm: '삭제',
      cancel: '취소',
    },
    alertLoadFail: '데이터를 불러오는데 실패했습니다.',
    alertUpdateSuccess: '권한 그룹이 수정되었습니다.',
    alertUpdateFail: '권한 그룹 수정에 실패했습니다.',
    alertDeleted: '"{name}" 권한 그룹이 삭제되었습니다.',
    alertDeleteFail: '권한 그룹 삭제에 실패했습니다. 해당 권한 그룹을 사용하는 사용자가 있을 수 있습니다.',
  },
  roleRegister: {
    title: '권한 등록',
    sectionBasic: '기본 정보',
    sectionPermissions: '권한 설정',
    nameLabel: '권한명',
    namePlaceholder: '권한명을 입력하세요',
    codeLabel: '권한코드',
    codePlaceholder: '예: ADMIN, MANAGER',
    descriptionLabel: '설명',
    descriptionPlaceholder: '권한에 대한 설명을 입력하세요',
    cancel: '취소',
    submit: '권한 등록',
    alertNameRequired: '권한명을 입력해주세요.',
    alertCodeRequired: '권한코드를 입력해주세요.',
    alertCreateSuccess: '권한이 등록되었습니다.',
    alertCreateFail: '권한 등록에 실패했습니다.',
    alertCodeDuplicate: '이미 사용 중인 권한코드입니다.',
    alertLoadFail: '권한 목록을 불러오지 못했습니다.',
    confirmCancel: '작성 중인 내용이 저장되지 않습니다. 취소하시겠습니까?',
  },
};

export default user;
